import React, { useEffect, useState } from "react";
import { authFetch } from "../../api/api";
import Card from "../../UI/Card";
import Button from "../../UI/Button";
import { useTranslation } from "react-i18next";


const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;

const PRODUCTS_API = `${BASE_URL}/api/products/`;
const PRICE_API = `${BASE_URL}/api/client-prices/`;
const ORDER_ITEMS_API = `${BASE_URL}/api/order-items/`;

export default function AddProductModal({
  orderId,
  clientId,
  onClose,
  onSuccess,
  editItem,
}) {
  const [products, setProducts] = useState([]);

  const [selectedProduct, setSelectedProduct] = useState(null);

  const [quantity, setQuantity] = useState(1);
  const [clientPrice, setClientPrice] = useState(0);
  const [purchasePrice, setPurchasePrice] = useState(0);
  const [comment, setComment] = useState("");
  const [clientPrices, setClientPrices] = useState([]);

  const { t } = useTranslation("OrdersPage");

  // 🔥 OVERRIDE FLAGS
  const [overrideClientPrice, setOverrideClientPrice] = useState(false);
  const [overridePurchasePrice, setOverridePurchasePrice] = useState(false);

  const [loading, setLoading] = useState(false);

  // =========================
  // LOAD PRODUCTS
  // =========================
  useEffect(() => {
    const load = async () => {
      try {
        const res = await authFetch(PRODUCTS_API);
        const data = await res.json();
        setProducts(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error(e);
      }
    };
    load();
  }, []);






//получаем цены для клиентов
  useEffect(() => {
    const loadClientPrices = async () => {
      const res = await authFetch(`${PRICE_API}?client=${clientId}`);
      const data = await res.json();
      setClientPrices(data);
    };
    loadClientPrices();
  }, [clientId]);

//функция получения цен согласно кол-ву
  const getTiers = (productId) => {
    const entry = clientPrices.find(
      (p) => p.product === productId
    );
    return entry?.price_tiers || [];
  };


  /*функция чтобы считать цену в зависимости от кол-ва */
  const getClientPrice = (productId, qty, product) => {
    const clientPriceItem = clientPrices.find(
      (p) => p.product === productId
    );
    // если есть диапазоны
    const tiers = clientPriceItem?.price_tiers || [];
    if (tiers.length > 0) {
      const q = Number(qty);
      const tier = tiers.find((t) => {
        const min = Number(t.min_qty);
        const max =
          t.max_qty === null
            ? Infinity
            : Number(t.max_qty);
        return q >= min && q <= max;
      });
      // нашли диапазон
      if (tier) {
        return Number(tier.price);
      }
    }
    // если диапазона нет или количество вне диапазона
    // берем обычную цену клиента
    if (clientPriceItem?.price) {
      return Number(clientPriceItem.price);
    }
    // если вообще нет цены клиента
    // берем цену товара
    return Number(
      product?.standard_price || 0
    );
  };


  const getPurchasePrice = (product, qty) => {
    const tiers = product?.price_tiers || [];
    if (tiers.length > 0) {
      const q = Number(qty);
      const tier = tiers.find((t) => {
        const min = Number(t.min_qty);
        const max =
          t.max_qty === null
            ? Infinity
            : Number(t.max_qty);
        return q >= min && q <= max;
      });
      if (tier) {
        return Number(tier.price);
      }
    }
    return Number(product?.purchase_price || 0);
  };

  useEffect(() => {
    if (!selectedProduct) return;
    if (overridePurchasePrice) return;

    const price = getPurchasePrice(
      selectedProduct,
      quantity
    );

    setPurchasePrice(price);

  }, [
    selectedProduct,
    quantity,
    overridePurchasePrice
  ]);

  useEffect(() => {

    if (!selectedProduct) return;
    if (overrideClientPrice) return;
    if (!clientPrices.length) return;


    const price = getClientPrice(
      selectedProduct.id,
      quantity,
      selectedProduct
    );


    setClientPrice(price);


  }, [
    quantity,
    clientPrices
  ]);




  // =========================
  // INIT EDIT MODE
  // =========================
  useEffect(() => {
    if (!editItem) {
      setSelectedProduct(null);
      setQuantity(1);
      setClientPrice(0);
      setPurchasePrice(0);
      setComment("");

      setOverrideClientPrice(false);
      setOverridePurchasePrice(false);
      return;
    }

    setSelectedProduct({
      id: editItem.product,
      ...editItem.product_data,
    });

    setQuantity(editItem.quantity || 1);
    setClientPrice(editItem.client_price || 0);
    setPurchasePrice(editItem.purchase_price || 0);
    setComment(editItem.comment || "");

    setOverrideClientPrice(!!editItem.is_client_price_overridden);
    setOverridePurchasePrice(!!editItem.is_purchase_price_overridden);
  }, [editItem]);






  // =========================
  // SELECT PRODUCT
  // =========================
  const handleSelectProduct = async (product) => {
    if (!product) return;

    setSelectedProduct(product);

    try {
      const res = await authFetch(
        `${PRICE_API}?client=${clientId}&product=${product.id}`
      );

      const data = await res.json();

      const clientPriceItem = data.find(
        (item) => item.product === product.id
      );


      if (!overrideClientPrice) {

        let finalPrice = 0;

        // 1. сначала проверяем диапазоны
        const tiers = clientPriceItem?.price_tiers || [];

        if (tiers.length > 0) {

          const q = Number(quantity);

          const tier = tiers.find((t) => {
            const min = Number(t.min_qty);
            const max =
              t.max_qty === null
                ? Infinity
                : Number(t.max_qty);

            return q >= min && q <= max;
          });


          if (tier) {
            finalPrice = Number(tier.price);
          }
        }


        // 2. если диапазон не подошел - берем обычную цену клиента
        if (!finalPrice && clientPriceItem?.price) {
          finalPrice = Number(clientPriceItem.price);
        }


        // 3. если у клиента цены нет - берем цену товара
        if (!finalPrice) {
          finalPrice = Number(product.standard_price || 0);
        }


        setClientPrice(finalPrice);
      }



      // закупочная цена
      if (!overridePurchasePrice) {
        setPurchasePrice(
          getPurchasePrice(product, quantity)
        );
      }


    } catch (e) {

      console.error(e);

      if (!overrideClientPrice) {
        setClientPrice(
          Number(product.standard_price || 0)
        );
      }

      if (!overridePurchasePrice) {
        setPurchasePrice(
          Number(product.purchase_price || 0)
        );
      }
    }
  };

  // =========================
  // SUBMIT
  // =========================
  const handleSubmit = async () => {
    if (!selectedProduct?.id) {
      alert("Выбери товар");
      return;
    }

    setLoading(true);

    try {
      const isEdit = Boolean(editItem);

      const url = isEdit
        ? `${ORDER_ITEMS_API}${editItem.id}/`
        : ORDER_ITEMS_API;

      const method = isEdit ? "PUT" : "POST";

      const payload = {
        order: Number(orderId),
        product: selectedProduct.id,
        quantity: Number(quantity),
        client_price: Number(clientPrice),
        purchase_price: Number(purchasePrice),
        comment: comment || "",

        is_client_price_overridden: overrideClientPrice,
        is_purchase_price_overridden: overridePurchasePrice,
      };

      const res = await authFetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json().catch(() => null);

      if (!res.ok) {
        console.error("ORDER ITEM ERROR:", data);
        alert(JSON.stringify(data));
        return;
      }

      onSuccess?.(data);
      onClose?.();
    } catch (e) {
      console.error(e);
      alert("Ошибка сети");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center">
      <Card className="w-[520px] p-4 space-y-4">

        <h2 className="text-lg font-bold">
          {editItem ? t("edit_product") : t("add_product")}
        </h2>

        {/* PRODUCT */}
        <ProductAutocomplete
          products={products}
          value={selectedProduct?.id}
          onChange={handleSelectProduct}
        />

        {/* QTY */}
        <input
          type="number"
          className="border p-2 w-full"
          value={quantity}
          onChange={(e) => setQuantity(e.target.value)}
          placeholder={t("quantity")}
        />

        {/* CLIENT PRICE */}
        <div className="space-y-1">
          <input
            type="number"
            className="border p-2 w-full"
            value={clientPrice}
            disabled={!overrideClientPrice}
            onChange={(e) => setClientPrice(e.target.value)}
            placeholder={t("price_for_client")}
          />

          <label className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              checked={overrideClientPrice}
              onChange={(e) => setOverrideClientPrice(e.target.checked)}
            />
            {t("override_client_price")}
          </label>
        </div>

        {/* PURCHASE PRICE */}
        <div className="space-y-1">
          <input
            type="number"
            className="border p-2 w-full"
            value={purchasePrice}
            disabled={!overridePurchasePrice}
            onChange={(e) => setPurchasePrice(e.target.value)}
            placeholder={t("purchase_price")}
          />

          <label className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              checked={overridePurchasePrice}
              onChange={(e) => setOverridePurchasePrice(e.target.checked)}
            />
            {t("override_purchase_price")}
          </label>
        </div>

        {/* COMMENT */}
        <textarea
          className="border p-2 w-full"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder={t("comment")}
        />

        {/* ACTIONS */}
        <div className="flex justify-between">
          <Button onClick={onClose}>{t("cancel")}</Button>

          <Button onClick={handleSubmit} disabled={loading}>
            {loading
              ? t("saving")
              : editItem
              ? t("save")
              : t("add")}
          </Button>
        </div>

      </Card>
    </div>
  );
}

// =========================
// AUTOCOMPLETE
// =========================
function ProductAutocomplete({ products, value, onChange }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  const selected = products.find((p) => p.id === value);

  const filtered = products.filter((p) =>
    `${p.name_en} ${p.name_cn || ""}`
      .toLowerCase()
      .includes(search.toLowerCase())
  );
  const { t } = useTranslation("OrdersPage");

  return (
    <div className="relative">

      <input
        className="border p-2 w-full"
        placeholder={t("select_product")}
        value={
          open
            ? search
            : selected
            ? `${selected.name_en} / ${selected.name_cn || ""}`
            : ""
        }
        onFocus={() => setOpen(true)}
        onChange={(e) => {
          setSearch(e.target.value);
          setOpen(true);
          onChange(null);
        }}
      />

      {open && (
        <div className="absolute z-50 bg-white border w-full max-h-60 overflow-auto">

          {filtered.length === 0 && (
            <div className="p-2 text-gray-400">{t("no_results")}</div>
          )}

          {filtered.map((p) => (
            <div
              key={p.id}
              className="p-2 hover:bg-gray-200 cursor-pointer"
              onClick={() => {
                onChange(p);
                setSearch("");
                setOpen(false);
              }}
            >
              {p.name_en} / {p.name_cn || ""}
            </div>
          ))}

        </div>
      )}

    </div>
  );
}
